// Generated by purs version 0.14.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Console from "../Effect.Console/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Specular_Internal_Incremental_Array from "../Specular.Internal.Incremental.Array/index.js";
import * as Specular_Internal_Incremental_Effect from "../Specular.Internal.Incremental.Effect/index.js";
import * as Specular_Internal_Incremental_Global from "../Specular.Internal.Incremental.Global/index.js";
import * as Specular_Internal_Incremental_MutableArray from "../Specular.Internal.Incremental.MutableArray/index.js";
import * as Specular_Internal_Incremental_Node from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular_Internal_Incremental_Optional from "../Specular.Internal.Incremental.Optional/index.js";
import * as Specular_Internal_Incremental_PriorityQueue from "../Specular.Internal.Incremental.PriorityQueue/index.js";
import * as Specular_Internal_Incremental_Ref from "../Specular.Internal.Incremental.Ref/index.js";
import * as Specular_Internal_Profiling from "../Specular.Internal.Profiling/index.js";
var Var = function (x) {
    return x;
};
var Event = function (x) {
    return x;
};
var traceChanges = function (fn, input) {
    return Specular_Internal_Incremental_Node.create({
        compute: function (_node) {
            var value_opt = Specular_Internal_Incremental_Node.get_value(input);
            var isFiring = Specular_Internal_Incremental_Node.isChangingInCurrentStabilization(input);
            (function () {
                if (isFiring) {
                    return fn(Specular_Internal_Incremental_Optional.fromSome(value_opt));
                };
                return Data_Unit.unit;
            })();
            return value_opt;
        },
        dependencies: Control_Applicative.pure(Effect.applicativeEffect)([ Specular_Internal_Incremental_Node.toSomeNode(input) ])
    });
};
var sample = function (fn, signal, clock) {
    return Specular_Internal_Incremental_Node.create({
        compute: function (_node) {
            var hasInput = Specular_Internal_Incremental_Node.isChangingInCurrentStabilization(clock);
            var result = (function () {
                if (hasInput) {
                    var signal_value = Specular_Internal_Incremental_Node.valueExc(signal);
                    var clock_value = Specular_Internal_Incremental_Node.valueExc(clock);
                    return fn(signal_value, clock_value);
                };
                return Specular_Internal_Incremental_Optional.none;
            })();
            return result;
        },
        dependencies: Control_Applicative.pure(Effect.applicativeEffect)([ Specular_Internal_Incremental_Node.toSomeNode(signal), Specular_Internal_Incremental_Node.toSomeNode(clock) ])
    });
};
var readVar = function (v) {
    return v;
};
var readEvent = function (v) {
    return v;
};
var newVar = function (val) {
    var node = Specular_Internal_Incremental_Node.create({
        compute: function (node) {
            var value = Specular_Internal_Incremental_Node.valueExc(node);
            return Specular_Internal_Incremental_Optional.some(value);
        },
        dependencies: Control_Applicative.pure(Effect.applicativeEffect)([  ])
    });
    Specular_Internal_Incremental_Node.set_value(node, Specular_Internal_Incremental_Optional.some(val));
    return node;
};
var newEvent = function __do() {
    var node = Specular_Internal_Incremental_Node.create({
        compute: function (node) {
            return Specular_Internal_Incremental_Node.get_value(node);
        },
        dependencies: Control_Applicative.pure(Effect.applicativeEffect)([  ])
    });
    return node;
};
var mapOptional = function (fn, a) {
    var deps = [ Specular_Internal_Incremental_Node.toSomeNode(a) ];
    return Specular_Internal_Incremental_Node.create({
        compute: function (v) {
            var value_a = Specular_Internal_Incremental_Node.get_value(a);
            var $15 = Specular_Internal_Incremental_Optional.isSome(value_a);
            if ($15) {
                return fn(Specular_Internal_Incremental_Optional.fromSome(value_a));
            };
            return Specular_Internal_Incremental_Optional.none;
        },
        dependencies: Control_Applicative.pure(Effect.applicativeEffect)(deps)
    });
};
var map2 = function (fn, a, b) {
    var deps = [ Specular_Internal_Incremental_Node.toSomeNode(a), Specular_Internal_Incremental_Node.toSomeNode(b) ];
    return Specular_Internal_Incremental_Node.create({
        compute: function (v) {
            var value_a = Specular_Internal_Incremental_Node.valueExc(a);
            var value_b = Specular_Internal_Incremental_Node.valueExc(b);
            return Specular_Internal_Incremental_Optional.some(fn(value_a, value_b));
        },
        dependencies: Control_Applicative.pure(Effect.applicativeEffect)(deps)
    });
};
var map = function (fn, a) {
    var deps = [ Specular_Internal_Incremental_Node.toSomeNode(a) ];
    return Specular_Internal_Incremental_Node.create({
        compute: function (v) {
            var value_a = Specular_Internal_Incremental_Node.valueExc(a);
            return Specular_Internal_Incremental_Optional.some(fn(value_a));
        },
        dependencies: Control_Applicative.pure(Effect.applicativeEffect)(deps)
    });
};
var leftmost = function (inputs) {
    return Specular_Internal_Incremental_Node.create({
        compute: function (_node) {
            return Specular_Internal_Incremental_Effect.foreachUntil(inputs, function (input) {
                var isFiring = Specular_Internal_Incremental_Node.isChangingInCurrentStabilization(input);
                if (isFiring) {
                    return Specular_Internal_Incremental_Node.get_value(input);
                };
                return Specular_Internal_Incremental_Optional.none;
            });
        },
        dependencies: Control_Applicative.pure(Effect.applicativeEffect)(Specular_Internal_Incremental_Node.toSomeNodeArray(inputs))
    });
};
var isTracing = false;
var trace = (function () {
    if (isTracing) {
        return Effect_Console.log;
    };
    return function (v) {
        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
    };
})();
var globalRecomputeQueue = Effect_Unsafe.unsafePerformEffect(function () {
    return Specular_Internal_Incremental_PriorityQueue["new"](Specular_Internal_Incremental_Optional.none, "height", "inRecomputeQueue", "nextInRecomputeQueue");
});
var setVar = function (v, val) {
    Specular_Internal_Incremental_Node.set_value(v, Specular_Internal_Incremental_Optional.some(val));
    Specular_Internal_Incremental_PriorityQueue.add(globalRecomputeQueue, Specular_Internal_Incremental_Node.toSomeNode(v));
    return Data_Unit.unit;
};
var triggerEvent = function (v, val) {
    Specular_Internal_Incremental_Node.set_value(v, Specular_Internal_Incremental_Optional.some(val));
    Specular_Internal_Incremental_PriorityQueue.add(globalRecomputeQueue, Specular_Internal_Incremental_Node.toSomeNode(v));
    return Data_Unit.unit;
};
var fold = function (fn, initial, a) {
    var deps = [ Specular_Internal_Incremental_Node.toSomeNode(a) ];
    return Specular_Internal_Incremental_Node.create({
        compute: function (node) {
            var state_opt = Specular_Internal_Incremental_Node.get_value(node);
            var state = (function () {
                var $20 = Specular_Internal_Incremental_Optional.isSome(state_opt);
                if ($20) {
                    return Specular_Internal_Incremental_Optional.fromSome(state_opt);
                };
                return initial;
            })();
            var hasInput = Specular_Internal_Incremental_Node.isChangingInCurrentStabilization(a);
            var result = (function () {
                if (hasInput) {
                    var input = Specular_Internal_Incremental_Node.valueExc(a);
                    return fn(input, state);
                };
                return Specular_Internal_Incremental_Optional.some(state);
            })();
            return result;
        },
        dependencies: Control_Applicative.pure(Effect.applicativeEffect)(deps)
    });
};
var ensureHeight = function (node, newHeight) {
    var oldAdjustedHeight = Specular_Internal_Incremental_Node.get_adjustedHeight(node);
    return Specular_Internal_Incremental_Node.set_adjustedHeight(node, Data_Ord.max(Data_Ord.ordInt)(oldAdjustedHeight)(newHeight));
};
var recomputeNode = function (node) {
    var height = Specular_Internal_Incremental_Node.get_height(node);
    var adjustedHeight = Specular_Internal_Incremental_Node.get_adjustedHeight(node);
    var $22 = adjustedHeight > height;
    if ($22) {
        var mark = Specular_Internal_Profiling.begin("bump height " + Specular_Internal_Incremental_Node.name(node));
        var dependents = Specular_Internal_Incremental_Node.get_dependents(node);
        Specular_Internal_Incremental_MutableArray.iterate(dependents, function (dependent) {
            return ensureHeight(dependent, adjustedHeight + 1 | 0);
        });
        Specular_Internal_Incremental_Node.set_height(node, adjustedHeight);
        Specular_Internal_Incremental_PriorityQueue.add(globalRecomputeQueue, node);
        return Specular_Internal_Profiling.end(mark);
    };
    var mark = Specular_Internal_Profiling.begin("compute " + Specular_Internal_Incremental_Node.name(node));
    var source = Specular_Internal_Incremental_Node.get_source(node);
    var newValue_opt = source.compute(node);
    (function () {
        var $23 = Specular_Internal_Incremental_Optional.isSome(newValue_opt);
        if ($23) {
            var newValue = Specular_Internal_Incremental_Optional.fromSome(newValue_opt);
            Specular_Internal_Incremental_Node.set_value(node, Specular_Internal_Incremental_Optional.some(newValue));
            var currentStabilizationNum = Specular_Internal_Incremental_Ref.read(Specular_Internal_Incremental_Global.globalCurrentStabilizationNum);
            Specular_Internal_Incremental_Node.set_changedAt(node, currentStabilizationNum);
            var dependents = Specular_Internal_Incremental_Node.get_dependents(node);
            Specular_Internal_Incremental_MutableArray.iterate(dependents, function (dependent) {
                var _added = Specular_Internal_Incremental_PriorityQueue.add(globalRecomputeQueue, dependent);
                return Data_Unit.unit;
            });
            var observers = Specular_Internal_Incremental_Node.get_observers(node);
            return Specular_Internal_Incremental_MutableArray.iterate(observers, function (observer) {
                return observer(newValue);
            });
        };
        return Data_Unit.unit;
    })();
    return Specular_Internal_Profiling.end(mark);
};
var stabilize = function __do() {
    var mark = Specular_Internal_Profiling.begin("stabilize");
    var oldStabilizationNum = Specular_Internal_Incremental_Ref.read(Specular_Internal_Incremental_Global.globalLastStabilizationNum);
    var currentStabilizationNum = oldStabilizationNum + 1 | 0;
    Specular_Internal_Incremental_Ref.write(Specular_Internal_Incremental_Global.globalLastStabilizationNum, currentStabilizationNum);
    Specular_Internal_Incremental_Ref.write(Specular_Internal_Incremental_Global.globalCurrentStabilizationNum, currentStabilizationNum);
    Specular_Internal_Incremental_PriorityQueue.drain(globalRecomputeQueue, recomputeNode);
    Specular_Internal_Incremental_Ref.write(Specular_Internal_Incremental_Global.globalCurrentStabilizationNum, Specular_Internal_Incremental_Global.stabilizationIsNotInProgress);
    return Specular_Internal_Profiling.end(mark);
};
var effectCrash = function (msg) {
    return function (v) {
        return Partial_Unsafe.unsafeCrashWith(msg);
    };
};
var constant = function (value) {
    return Specular_Internal_Incremental_Node.create({
        compute: function (v) {
            return Specular_Internal_Incremental_Optional.some(value);
        },
        dependencies: Control_Applicative.pure(Effect.applicativeEffect)([  ])
    });
};
var removeDependent = function (node, dependent) {
    var oldRefcount = Specular_Internal_Incremental_Node.refcount(node);
    var dependents = Specular_Internal_Incremental_Node.get_dependents(node);
    Specular_Internal_Incremental_MutableArray.remove(dependents, dependent);
    return handleRefcountChange(node, oldRefcount);
};
var handleRefcountChange = function (node, oldRefcount) {
    var newcount = Specular_Internal_Incremental_Node.refcount(node);
    (function () {
        var $24 = oldRefcount === 0 && newcount > 0;
        if ($24) {
            return connect(node);
        };
        var $25 = oldRefcount > 0 && newcount === 0;
        if ($25) {
            return disconnect(node);
        };
        return Data_Unit.unit;
    })();
    var oldTotalRefcount = Specular_Internal_Incremental_Ref.read(Specular_Internal_Incremental_Global.globalTotalRefcount);
    return Specular_Internal_Incremental_Ref.write(Specular_Internal_Incremental_Global.globalTotalRefcount, (oldTotalRefcount - oldRefcount | 0) + newcount | 0);
};
var disconnect = function (node) {
    var mark = Specular_Internal_Profiling.begin("disconnect " + Specular_Internal_Incremental_Node.name(node));
    var source = Specular_Internal_Incremental_Node.get_source(node);
    var dependencies = source.dependencies();
    Specular_Internal_Incremental_Array.iterate(dependencies, function (dependency) {
        return removeDependent(dependency, Specular_Internal_Incremental_Node.toSomeNode(node));
    });
    return Specular_Internal_Profiling.end(mark);
};
var connect = function (node) {
    var mark = Specular_Internal_Profiling.begin("connect " + Specular_Internal_Incremental_Node.name(node));
    var source = Specular_Internal_Incremental_Node.get_source(node);
    var dependencies = source.dependencies();
    Specular_Internal_Incremental_Array.iterate(dependencies, function (dependency) {
        addDependent(dependency, Specular_Internal_Incremental_Node.toSomeNode(node));
        var dependencyHeight = Specular_Internal_Incremental_Node.get_height(dependency);
        var ourHeight = Specular_Internal_Incremental_Node.get_height(node);
        var $26 = (dependencyHeight + 1 | 0) > ourHeight;
        if ($26) {
            Specular_Internal_Incremental_Node.set_height(node, dependencyHeight + 1 | 0);
            return Specular_Internal_Incremental_Node.set_adjustedHeight(node, dependencyHeight + 1 | 0);
        };
        return Data_Unit.unit;
    });
    var value = source.compute(node);
    Specular_Internal_Incremental_Node.set_value(node, value);
    return Specular_Internal_Profiling.end(mark);
};
var addDependent = function (node, dependent) {
    var oldRefcount = Specular_Internal_Incremental_Node.refcount(node);
    var dependents = Specular_Internal_Incremental_Node.get_dependents(node);
    Specular_Internal_Incremental_MutableArray.push(dependents, dependent);
    return handleRefcountChange(node, oldRefcount);
};
var addObserver = function (node, observer) {
    var oldRefcount = Specular_Internal_Incremental_Node.refcount(node);
    var observers = Specular_Internal_Incremental_Node.get_observers(node);
    Specular_Internal_Incremental_MutableArray.push(observers, observer);
    return handleRefcountChange(node, oldRefcount);
};
var removeObserver = function (node, observer) {
    var oldRefcount = Specular_Internal_Incremental_Node.refcount(node);
    var observers = Specular_Internal_Incremental_Node.get_observers(node);
    Specular_Internal_Incremental_MutableArray.remove(observers, observer);
    return handleRefcountChange(node, oldRefcount);
};
var $$switch = function (alwaysFire, lhs, fn) {
    var main_node_ref = Specular_Internal_Incremental_Ref["new"](Specular_Internal_Incremental_Optional.none);
    var rhs_node = Specular_Internal_Incremental_Node.create({
        compute: function (node) {
            var value_lhs = Specular_Internal_Incremental_Node.valueExc(lhs);
            var rhs = fn(value_lhs);
            var main_opt = Specular_Internal_Incremental_Ref.read(main_node_ref);
            var main = Specular_Internal_Incremental_Optional.fromSome(main_opt);
            addDependent(rhs, Specular_Internal_Incremental_Node.toSomeNode(main));
            var dependencyHeight = Specular_Internal_Incremental_Node.get_height(rhs);
            ensureHeight(main, dependencyHeight + 1 | 0);
            var old_rhs_opt = Specular_Internal_Incremental_Node.get_value(node);
            (function () {
                var $27 = Specular_Internal_Incremental_Optional.isSome(old_rhs_opt);
                if ($27) {
                    return removeDependent(Specular_Internal_Incremental_Optional.fromSome(old_rhs_opt), Specular_Internal_Incremental_Node.toSomeNode(main));
                };
                return Data_Unit.unit;
            })();
            return Specular_Internal_Incremental_Optional.some(rhs);
        },
        dependencies: Control_Applicative.pure(Effect.applicativeEffect)([ Specular_Internal_Incremental_Node.toSomeNode(lhs) ])
    });
    Specular_Internal_Incremental_Node.annotate(rhs_node, "switch data");
    var main = Specular_Internal_Incremental_Node.create({
        compute: function (v) {
            var rhs = Specular_Internal_Incremental_Node.valueExc(rhs_node);
            var isFiring = Specular_Internal_Incremental_Node.isChangingInCurrentStabilization(rhs);
            var $28 = alwaysFire || isFiring;
            if ($28) {
                return Specular_Internal_Incremental_Node.get_value(rhs);
            };
            return Specular_Internal_Incremental_Optional.none;
        },
        dependencies: function __do() {
            var rhs_opt = Specular_Internal_Incremental_Node.get_value(rhs_node);
            var $29 = Specular_Internal_Incremental_Optional.isSome(rhs_opt);
            if ($29) {
                return [ Specular_Internal_Incremental_Node.toSomeNode(rhs_node), Specular_Internal_Incremental_Node.toSomeNode(Specular_Internal_Incremental_Optional.fromSome(rhs_opt)) ];
            };
            return [ Specular_Internal_Incremental_Node.toSomeNode(rhs_node) ];
        }
    });
    Specular_Internal_Incremental_Ref.write(main_node_ref, Specular_Internal_Incremental_Optional.some(main));
    return main;
};
var bind_ = function (lhs, fn) {
    return $$switch(true, lhs, fn);
};
export {
    globalRecomputeQueue,
    Var,
    newVar,
    setVar,
    readVar,
    Event,
    newEvent,
    triggerEvent,
    readEvent,
    addObserver,
    removeObserver,
    addDependent,
    removeDependent,
    handleRefcountChange,
    connect,
    disconnect,
    stabilize,
    recomputeNode,
    constant,
    map,
    mapOptional,
    map2,
    bind_,
    $$switch as switch,
    fold,
    sample,
    leftmost,
    traceChanges,
    ensureHeight,
    effectCrash,
    isTracing,
    trace
};
//# sourceMappingURL=index.js.map
